
























































import { Vue, Component } from 'vue-property-decorator';
import PagingUnit from '@/components/paging/paging.vue'; // 导入分页组件
import { TableStripe } from '@/mixins/tableStripe';
import { dictServe, doublePrevention } from '@/api/installServer';
import ApprovalDetail from './approvalDetail.vue';

@Component({
  components: { PagingUnit, ApprovalDetail },
  mixins: [TableStripe],
})
export default class ApprovalList extends Vue {
  private showPublicPage = false;
  private rowData: any = {};

  private tableLoading = false; // loading...
  private tableData: any = []; // 表格数据
  private queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };
  private total = 0;
  private approvalType: any = {};
  private multipleSelection: any = [];

  created() {
    this.getTableData();
    this.getApprovalType();
  }
  //   批量导出表格
  handleSelectionChange(val: any) {
    this.multipleSelection = val;
  }
  private batchApproval() {
    if (!this.multipleSelection.length) {
      this.$message.warning('请选择需要审核的数据');
      return;
    }
    const selectId: any = this.multipleSelection.map((item: any) => {
      return item.id;
    });
    this.$confirm('审核是否继续？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        doublePrevention.approvalRiskControlInventoryHandle(selectId).then((res: any) => {
          if (res.code == 200) {
            this.$message.success('审核完成！');
            this.getTableData();
          } else {
            this.$message.warning(res.msg);
          }
        });
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消',
        });
      });
  }
  getApprovalType() {
    dictServe.getDetailsMapByName('approvalType').then((res: any) => {
      if (res.code === '200') {
        this.approvalType = res.data;
      }
    });
  }
  private getTableData() {
    this.tableLoading = true;
    doublePrevention
      .getApprovalRiskControlInventoryList({
        current: this.queryDataForm.pageNo,
        size: this.queryDataForm.pageSize,
      })
      .then((res: any) => {
        if (res.code == 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
          this.tableLoading = false;
        } else {
          this.tableLoading = false;
          this.$message.warning(res.data.msg);
        }
      });
  }

  private backToRiskPage() {
    this.showPublicPage = false;
    this.getTableData();
  }

  private getListData() {
    this.getTableData();
  }
  private jumpToPublicPage(type: any, data: any) {
    const objForm: any = {
      id: data.id,
      rowType: data.type,
      type: type,
    };
    this.rowData = objForm;
    switch (type) {
      case 'detail':
        this.showPublicPage = true;
        break;
      case 'approval':
        this.showPublicPage = true;
        break;
      case 'delete':
        this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.deleteLawsRegulations(data.id);
          })
          .catch(() => {
            this.$message.info('已取消删除');
          });
        break;
    }
  }
  // 删除
  private deleteLawsRegulations(id: any) {
    doublePrevention.delApprovalRiskControlInventoryData(id).then((res: any) => {
      if (res.code === '200') {
        this.$message.success('删除成功');
        this.getTableData();
      } else {
        this.$message.warning(res.msg);
      }
    });
  }
}
